import { render, staticRenderFns } from "./MenuGerarAta.vue?vue&type=template&id=b39cec3e&scoped=true"
import script from "./MenuGerarAta.vue?vue&type=script&lang=js"
export * from "./MenuGerarAta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39cec3e",
  null
  
)

export default component.exports